export const environment = {
  production: false,
  serverUrl: 'https://backofficedev.gigalixirapp.com/api/v1',
  enableErrorReporting: true,
  sentryKey: 'https://532d423e3e3b438bb4957a35f64a8c16@sentry.thesunflowerlab.com/25',
  enableAutoUpdateCheck: true,
  socialRedirectUri: 'https://ogantry.thesunflowerlab.com',
  enableFeatureToggle: true
};
